const getServiceWorkerRegistration = async (): Promise<ServiceWorkerRegistration | null> => {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return null;
  }
  try {
    return await navigator.serviceWorker.ready;
  } catch {
    return null;
  }
};

export const dismissWebPushByTag = async (tag: string): Promise<void> => {
  const registration = await getServiceWorkerRegistration();
  if (!registration?.active) return;

  registration.active.postMessage({
    type: 'CLOSE_NOTIFICATIONS',
    tag,
  });
};

export const dismissAllWebPush = async (): Promise<void> => {
  const registration = await getServiceWorkerRegistration();
  if (!registration?.active) return;

  registration.active.postMessage({
    type: 'CLOSE_ALL_NOTIFICATIONS',
  });
};
